import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import capitalize from 'scaleflow/utils/capitalize';

export default class PlanningDashboardGridController extends Controller {
  queryParams = [
    'column',
    'row',
    'effort',
    'uncertainties',
    'waiting',
    'updatedAt',
    'tickets',
  ];
  @tracked column = 'status';
  @tracked row = 'teams';
  @tracked effort = true;
  @tracked uncertainties = true;
  @tracked tfos = true;
  @tracked waiting = true;
  @tracked updatedAt = true;
  @tracked tickets = true;
  @tracked slideoverIsOpen = false;

  @service roadmap;
  @service intl;

  get activeFields() {
    return {
      effort: this.effort,
      uncertainties: this.uncertainties,
      tfos: this.tfos,
      waiting: this.waiting,
      updatedAt: this.updatedAt,
      tickets: this.tickets,
    };
  }

  @action
  setColumn(e) {
    this.column = e.value;
  }

  @action
  setRow(e) {
    this.row = e.value;
  }

  @action
  toggleFilterSlideover() {
    this.slideoverIsOpen = !this.slideoverIsOpen;
  }

  get options() {
    return [
      {
        label: capitalize(
          this.intl.t('_initiatives.source', {
            num: 1,
          }),
        ),
        value: 'source',
      },
      {
        label: capitalize(this.intl.t('_initiatives.status')),
        value: 'status',
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.teams', {
            num: 1,
          }),
        ),
        value: 'teams',
      },
      {
        label: capitalize(
          this.intl.t('_initiatives.themes', {
            num: 1,
          }),
        ),
        value: 'theme',
      },
      {
        label: capitalize(this.intl.t('_initiatives.progress')),
        value: 'latestUpdate',
      },
      {
        label: capitalize(
          this.intl.t('dictionary.goals', {
            num: 1,
          }),
        ),
        value: 'goals',
      },
    ];
  }

  @action
  excludeSelectedRowOption() {
    return this.options.filter((item) => item.value !== this.row);
  }

  @action
  excludeSelectedColumnOption() {
    return this.options.filter((item) => item.value !== this.column);
  }

  @action
  handleFilterSelect({ target: { name, checked } }) {
    this[name] = checked;
  }
}
